// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YI+Vh","header":"styles_header__iNeS-","alias":"styles_alias__+bniY","prize":"styles_prize__XlbUT","noWins":"styles_noWins__jYBn2"};